import PropTypes from "prop-types";
import clsx from "clsx";
import { RadioGroup, Radio, FormControlLabel } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useId } from "react";

RadioGroupCustom.propTypes = {
  items: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

function RadioGroupCustom({ className, ...props }) {
  const label = labelStyles();
  const radio = radioStyles();
  const uniqueId = useId();

  return (
    <div className={clsx("radio-group", className)}>
      {props.label && (
        <label htmlFor={uniqueId} className="select-label text-field__label">
          {props.label}
        </label>
      )}
      <RadioGroup
        row
        id={uniqueId}
        name="radio-group-custom"
        style={{ width: "500px" }}
        value={props.value}
        onChange={props.onChange}
      >
        {props.items.map((item) => {
          return (
            <FormControlLabel
              key={item.key}
              value={item.value}
              control={
                <Radio
                  disableRipple
                  className={clsx(radio.root, radio.checked)}
                  checkedIcon={
                    <div className={clsx(radio.icon, radio.checkedIcon)}>
                      <div className={radio.checkedIconDot}></div>
                    </div>
                  }
                  icon={<div className={radio.icon} />}
                />
              }
              label={item.text}
              classes={label}
            />
          );
        })}
      </RadioGroup>
    </div>
  );
}

const labelStyles = makeStyles((theme) => ({
  label: {
    fontSize: "14px !important",
    lineHeight: "20px !important",
    color: "#202020 !important",
  },
}));

const radioStyles = makeStyles((theme) => ({
  root: {
    color: "#0cb39f !important",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  checked: {
    color: "#0cb39f !important",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    backgroundColor: "transparent",
    border: "1px solid #EBEDF2",
  },
  checkedIconDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#016069",
  },
  checkedIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    backgroundImage: "none",
  },
}));

export default RadioGroupCustom;
